import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgToggleOff = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeWidth: 1.5,
			d: "M7.25 9.875a1.375 1.375 0 1 1-2.75 0 1.375 1.375 0 0 1 2.75 0Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeWidth: 1.5,
			d: "M1.75 10A4.25 4.25 0 0 1 6 5.75h8a4.25 4.25 0 0 1 0 8.5H6A4.25 4.25 0 0 1 1.75 10Z"
		})
	]
});
const ForwardRef = forwardRef(SvgToggleOff);
export { ForwardRef as ReactComponent };
